import React from "react";
import { Responsive } from "react-admin";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import DatePicker from "react-date-picker";
import Tooltip from "@material-ui/core/Tooltip";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { fade } from "@material-ui/core/styles/colorManipulator";
import { withStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import BlockIcon from "@material-ui/icons/Block";
import DeleteIcon from "@material-ui/icons/Delete";
import myRestClient from "../common/restClient";
import history from "../common/history";
import { showNotification } from "react-admin";
import { connect } from "react-redux";
import compose from "recompose/compose";
import { translate } from "ra-core";
import TranslatedText from "./TranslatedText";
import CircularProgress from "@material-ui/core/CircularProgress";
import tccStyles from "../common/styles";
import { getLoggedUser } from "../common/authClient";
//import { DISDETTA_MIN_DAYS } from "../config";
import { ENV_NAME } from "../config";

const DISDETTA_MIN_DAYS =
    ENV_NAME === "staging" || ENV_NAME === "development" ? 1 : 60;

const styles = theme => ({
    deleteButton: {
        color: theme.palette.error.main,
        "&:hover": {
            backgroundColor: fade(theme.palette.error.main, 0.12),
            // Reset on mouse devices
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    },
    confirmationDeleteButton: {
        color: "white",
        backgroundColor: theme.palette.error.main,
        "&:hover": {
            backgroundColor: theme.palette.error.main,
            // Reset on mouse devices
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    },
    calendar: {
        position: "fixed",
        color: tccStyles.productionColor.secondary
    },
    datepicker: {
        border: "thin solid",
        borderColor: tccStyles.productionColor.secondary
    }
});

class DeleteButton extends React.Component {
    state = {
        show_type_dialog: false,
        show_dialog: false,
        showSnackBar: false,
        opInProgress: false,
        delete_type: "DELETE_DISDETTA",
        dateValue: null,
        loggedUserId: null
    };

    componentDidMount() {
        let validDate = new Date();
        validDate.setDate(validDate.getDate() + DISDETTA_MIN_DAYS);
        this.setState({ dateValue: validDate });
        //OPERATORE
        getLoggedUser().then(logged_user => {
            if (logged_user) {
                this.setState({ loggedUserId: logged_user.id });
            }
        });
        if (!this.props.record.retention_available) {
            this.setState({ delete_type: "DELETE" });
        }
    }

    handleCancel = () => {
        this.setState({
            show_dialog: false,
            opInProgress: false,
            force: false
        });
    };

    handleCancelTypeDialog = () => {
        this.setState({
            show_type_dialog: false
        });
    };

    handleOkTypeDialog = () => {
        this.setState({
            show_type_dialog: false
        });
        let date_calendar = new Date(this.state.dateValue).toLocaleDateString();
        let array_date = date_calendar.split("/");
        let date_format =
            array_date[2] + "-" + array_date[1] + "-" + array_date[0];

        if (this.state.delete_type === "DELETE") {
            this.setState({ show_dialog: true });
        } else {
            const body = {
                id: this.props.record.id,
                data: {
                    action: "cancellation",
                    disabled: true,
                    disabled_at: date_format,
                    cancellation_user_id: this.state.loggedUserId
                }
            };
            myRestClient("UPDATE_NO_PREV", "installations", body).then(
                result => {
                    this.props.showNotification(
                        "Cancellazione per disdetta impostata correttamente"
                    );
                },
                errore =>
                    this.props.showNotification(
                        "Errore in salvataggio prenotazione per disdetta"
                    )
            );
        }
    };

    handleClick = () => {
        const { text, booking } = this.props;
        if (booking) {
            this.setState({
                show_type_dialog: true,
                show_dialog: false,
                force: false
            });
        } else {
            this.setState({
                show_type_dialog: false,
                show_dialog: true,
                force: false
            });
        }
        if (text === "Forza cancellazione") {
            this.setState({ force: true });
        }
    };

    handleOk = event => {
        const {
            record,
            resource,
            message,
            redirect,
            redirectQuery,
            callback
        } = this.props;
        let query = {
            id: record.id
        };
        if (this.state.force) {
            query["force"] = true;
        }
        this.setState({ opInProgress: true });
        const qRed = redirectQuery ? `/${redirectQuery}` : ``;
        const redirectUrl = `${redirect}${qRed}`;
        myRestClient("DELETE", resource, query).then(
            result => {
                const msg =
                    resource === "installations" &&
                    result &&
                    result.data &&
                    result.data.data &&
                    result.data.data.status
                        ? result.data.data.status
                        : message;
                this.setState({ show_dialog: false, opInProgress: false });
                this.props.showNotification(msg);
                if (redirectQuery) {
                    callback && callback(redirectQuery);
                } else if (redirect) {
                    history.push(`/${redirectUrl}`);
                }
            },
            error => {
                console.log(error);
                this.setState({ show_dialog: false, opInProgress: false });
                this.props.showNotification(error.message);
            }
        );
    };

    updateSelectedCancellation(delete_type_selected) {
        this.setState({ delete_type: delete_type_selected });
    }

    onChangeDate = event => {
        this.setState({ dateValue: event });
    };

    handleChange = event => {
        this.updateSelectedCancellation(event.target.value);
    };

    renderChoice = () => {
        const { classes = {}, className } = this.props;
        let validDate = new Date();
        validDate.setDate(validDate.getDate() + DISDETTA_MIN_DAYS);

        return (
            <React.Fragment>
                <FormControl>
                    <RadioGroup
                        name="select_company"
                        value={this.state.delete_type}
                        onChange={this.handleChange}
                    >
                        <FormControlLabel
                            key={"1"}
                            value={"DELETE_DISDETTA"}
                            control={<Radio />}
                            label={"Cancellazione per disdetta"}
                            disabled={!this.props.record.retention_available}
                        />
                        <DatePicker
                            onKeyDown={e => {
                                e.preventDefault();
                            }}
                            locale="it-IT"
                            onChange={this.onChangeDate}
                            value={this.state.dateValue}
                            minDate={validDate}
                            calendarClassName={classnames(
                                "ra-delete-button",
                                classes.calendar,
                                className
                            )}
                            className={classnames(
                                "ra-delete-button",
                                classes.datepicker,
                                className
                            )}
                            format="dd/MM/yy"
                            clearIcon={null}
                            disabled={!this.props.record.retention_available}
                        />
                        <FormControlLabel
                            key={"2"}
                            value={"DELETE"}
                            control={<Radio />}
                            label={"Cancellazione"}
                        />
                    </RadioGroup>
                </FormControl>
            </React.Fragment>
        );
    };

    renderDeleteTypeDialog() {
        return (
            this.state.show_type_dialog && (
                <Dialog
                    disableBackdropClick
                    disableEscapeKeyDown
                    maxWidth="xs"
                    open={this.state.show_type_dialog}
                >
                    <DialogTitle>
                        <b>
                            <TranslatedText
                                resource_name={
                                    "resources.installations.fields.motivation"
                                }
                            />
                        </b>
                    </DialogTitle>
                    <DialogContent>{this.renderChoice()}</DialogContent>
                    <DialogActions>
                        <div>
                            <Button
                                onClick={this.handleCancelTypeDialog}
                                color="primary"
                            >
                                <TranslatedText
                                    resource_name={"ra.actions.cancel"}
                                />
                            </Button>
                            <Button
                                onClick={this.handleOkTypeDialog}
                                variant="contained"
                                color="secondary"
                            >
                                <TranslatedText
                                    resource_name={"ra.actions.forward"}
                                />
                            </Button>
                        </div>
                    </DialogActions>
                </Dialog>
            )
        );
    }

    renderDialog() {
        const {
            classes = {},
            className,
            dialogContentTitle,
            dialogContentText,
            dialogConfirmText
        } = this.props;
        return this.state.show_dialog ? (
            <Dialog
                disableBackdropClick
                disableEscapeKeyDown
                maxWidth="xs"
                open={this.state.show_dialog}
            >
                <DialogTitle>
                    <b>
                        <TranslatedText
                            resource_name={
                                dialogContentTitle
                                    ? dialogContentTitle
                                    : "ra.actions.disable"
                            }
                        />
                    </b>
                </DialogTitle>
                <DialogContent>
                    <TranslatedText
                        resource_name={
                            dialogContentText
                                ? dialogContentText
                                : "ra.actions.deleteSelectedResource"
                        }
                    />
                </DialogContent>
                <DialogActions>
                    <div
                        align="center"
                        style={{
                            visibility: this.state.opInProgress
                                ? "visible"
                                : "hidden"
                        }}
                    >
                        {<CircularProgress />}
                    </div>
                    {!this.state.opInProgress && (
                        <div>
                            {" "}
                            <Button onClick={this.handleCancel} color="primary">
                                <TranslatedText
                                    resource_name={"ra.actions.cancel"}
                                />
                            </Button>
                            <Button
                                onClick={this.handleOk}
                                variant="contained"
                                color="secondary"
                                className={classnames(
                                    "ra-delete-button",
                                    classes.confirmationDeleteButton,
                                    className
                                )}
                            >
                                <TranslatedText
                                    resource_name={
                                        dialogConfirmText
                                            ? dialogConfirmText
                                            : "ra.actions.ok"
                                    }
                                />
                            </Button>
                        </div>
                    )}
                </DialogActions>
            </Dialog>
        ) : null;
    }

    renderIcon() {
        const { text } = this.props;
        if (text === "Forza cancellazione") {
            return null;
        }
        return text === "Cancella" ? <DeleteIcon /> : <BlockIcon />;
    }

    render() {
        const {
            classes = {},
            className,
            dialogContentText = null,
            text = "Disabilita"
        } = this.props;
        return (
            <span>
                <Button
                    onClick={this.handleClick}
                    className={classnames(
                        "ra-delete-button",
                        classes.deleteButton,
                        className
                    )}
                >
                    <Responsive
                        small={
                            <Tooltip
                                title={<TranslatedText resource_name={text} />}
                            >
                                {this.renderIcon()}
                            </Tooltip>
                        }
                        medium={
                            <React.Fragment>
                                {this.renderIcon()}
                                <span style={{ paddingLeft: "0.5em" }}>
                                    <TranslatedText resource_name={text} />
                                </span>
                            </React.Fragment>
                        }
                    />
                </Button>
                {this.renderDeleteTypeDialog()}
                {this.renderDialog(dialogContentText)}
            </span>
        );
    }
}

export default compose(
    connect(
        null,
        {
            showNotification
        }
    ),
    translate,
    withStyles(styles)
)(DeleteButton);



// WEBPACK FOOTER //
// ./src/components/DeleteButton.js